<template>
    <div class="card">
        <b-tabs nav-class="nav-tabs-custom" content-class="p-3 text-muted">
            <b-tab lazy>
                <template v-slot:title>
                    <span class="d-inline-block d-sm-none">
                        <i class="fas fa-home"></i>
                    </span>
                    <span class="d-none d-sm-inline-block">Overview</span>
                </template>
                <div class="card-body tabBody">
                    <Overview />
                </div>
            </b-tab>

            <b-tab active lazy>
                <template v-slot:title>
                    <span class="d-inline-block d-sm-none">
                        <i class="far fa-user"></i>
                    </span>
                    <span class="d-none d-sm-inline-block">Timeline</span>
                </template>
                <div class="card-body tabBody">
                    <Timeline />
                </div>
            </b-tab>

            <b-tab lazy>
                <template v-slot:title>
                    <span class="d-inline-block d-sm-none">
                        <i class="far fa-envelope"></i>
                    </span>
                    <span class="d-none d-sm-inline-block">Organogram</span>
                </template>
                <div class="card-body tabBody" style="min-height: unset !important;">
                    <OrgChart />
                </div>
            </b-tab>
            
            <b-tab lazy>
                <template v-slot:title>
                    <span class="d-inline-block d-sm-none">
                        <i class="fas fa-cog"></i>
                    </span>
                    <span class="d-none d-sm-inline-block">Users</span>
                </template>
                <div class="card-body tabBody">
                    <Users />
                </div>
            </b-tab>

            <b-tab lazy>
                <template v-slot:title>
                    <span class="d-inline-block d-sm-none">
                        <i class="fas fa-cog"></i>
                    </span>
                    <span class="d-none d-sm-inline-block">Modules</span>
                </template>
                <div class="card-body tabBody">
                    <Modules />
                </div>
            </b-tab>

            <b-tab lazy>
                <template v-slot:title>
                    <span class="d-inline-block d-sm-none">
                        <i class="fas fa-cog"></i>
                    </span>
                    <span class="d-none d-sm-inline-block">Documents</span>
                </template>
                <div class="card-body tabBody">
                    <Documents/>
                </div>
            </b-tab>

            <b-tab lazy>
                <template v-slot:title>
                    <span class="d-inline-block d-sm-none">
                        <i class="fas fa-cog"></i>
                    </span>
                    <span class="d-none d-sm-inline-block">Audits</span>
                </template>
                <div class="card-body tabBody">
                    <Audits/>
                </div>
            </b-tab>
        </b-tabs>
    </div>
</template>

<script>
import Documents from './documents.vue'
import OrgChart from './organogram.vue'
import Timeline from './timeline.vue'
import Users from './users.vue'
import Modules from './modules.vue'
import Overview from './overview.vue'
import Audits from './audits.vue'

export default {
    data:() => ({}),
    components:{
        Documents,
        Timeline,
        Users,
        Modules,
        Overview,
        Audits,
        /* eslint-disable-next-line */
        OrgChart

    },
    computed:{},
    methods:{},
    mounted(){},
}
</script>

<style>
.tabBody{
    width: 100%;
    min-height: 40rem;
}
</style>